import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
import { getAaffListSuplier } from "../../../services";
import { UsuarioContext } from "../../../providers/userContext";
import { useNavigate } from "react-router-dom";
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from './../../../functions/parametrosURL/funcionesParamsURL';
import { saveNavContext } from "../../../functions/navOrder";
import ProveedoresLegalia from "./diseños/legalia/proveedores";
import ProveedoresOriginal from "./diseños/original/proveedores";

const ProveedoresLista = () => {
  const { t } = useTranslation(['suppliers', 'common']);
  const user = useContext(UsuarioContext);
  const { filtrosIniciales, filtroOrder } = useRecogerURLParamsFiltros();
  const navigate = useNavigate();

  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [loading, setLoading] = useState(true);
  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });

  const clearFilters = () => {
    setBusqueda({});
    setClearFilterActivo(true);
  };

  const fetchData = async ({ offset, limit, filtros = busqueda, order, orderBy } = {}) => {
    orderBy = orderBy || filtroOrder.ordenadoPor || (user.tieneLegalia ? 'cumplimiento' : 'id');
    order = order || filtroOrder.orden || (user.tieneLegalia ? 'DESC' : 'ASC');
    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros, order, orderBy);
    // Contexto para las flechas anterior/siguiente del detalle de proveedor.
    saveNavContext('proveedores', { filtros, order, orderBy });

    const payload = {
      filtros,
      params: { page: offset, limit, order, orderBy },
    };

    try {
      setLoading(true);
      const response = await getAaffListSuplier(payload);
      const { meta, data } = response;

      setData({
        meta,
        rows: formatData(data),
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const formatData = (data) => {
    return data.map((row) => ({
      razonSocial: row.razonSocial,
      nif: row.nif,
      telefonoContacto: row.telefonoContacto,
      municipio: row.municipio,
      provincia: row.provincia,
      codigoPostal: row.codigoPostal,
      cumplimiento: row.porcentajeDocs === null ? 0 : row.porcentajeDocs,
      ultimaReclamacion: row.ultimaReclamacion,
      servicios: row.serviceSupps || [],
    }));
  };

  const filtrarDatos = (filtros) => {
    setBusqueda(filtros);
    setBusquedaActiva(true);
  };

  const sharedProps = {
    t,
    user,
    data,
    loading,
    fetchData,
    busqueda,
    filtrarDatos,
    clearFilters,
    busquedaActiva,
    setBusquedaActiva,
    clearFilterActivo,
    setClearFilterActivo,
  };

  return user.tieneLegalia ? (
    <ProveedoresLegalia {...sharedProps} />
  ) : (
    <ProveedoresOriginal {...sharedProps} />
  );
};

export default withRouter(ProveedoresLista);
